import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';

export const ResetButton = styled(Text.withComponent('button'))`
  border: none;
  background: none;
  outline: none;
`;
